// extracted by mini-css-extract-plugin
export default {"dark":"ZoomedLabertGraph_dark__qea1c","interface":"ZoomedLabertGraph_interface__E7LXU","graph_interface":"ZoomedLabertGraph_graph_interface__zxsAe"};